import React, { Component } from 'react'
import PropTypes from 'prop-types'
import '../components/css/IdeaOwner.css'
import * as helpers from '../lib/HelperFunctions'

class IdeaOwner extends Component {
    render() {
        // TODO: temp fix to invitee avatar being used will display NA if no ownername is passed
        let ownerName = this.props.ownerName ? this.props.ownerName : '?'
        if(ownerName === 'responsible') {
            ownerName = '?  '
        }
        let photoURL = this.props.ownerPhotoURL ? this.props.ownerPhotoURL : 'https://ui-avatars.com/api/?name='+ownerName+'&color=707070&background=cccccc&size=60'
        if(photoURL === '/invitee_avatar.jpg' || photoURL === 'https://ui-avatars.com/api/?name=null&color=707070&background=cccccc&size=60'){
            photoURL = 'https://ui-avatars.com/api/?name='+ownerName+'&color=707070&background=cccccc&size=60'
        }
        return (
            <div>
                <div className='ideaOwnerContainer'>
                    <img onError={(e)=>{helpers.onImageError(e, ownerName)}} className='ideaOwnerImage' src={photoURL} alt='IdeaOwnerPhoto' />
                </div>
            </div>
        )
    }
}
IdeaOwner.propTypes = {
    ownerName: PropTypes.string,
    ownerPhotoURL: PropTypes.string,
}

export default IdeaOwner



// WEBPACK FOOTER //
// ./src/components/IdeaOwner.js